import useGet from "#hooks/useGet.js";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import React, { useEffect } from "react";

// Create a reusable component for GrowerDetailCard
const GrowerDetailCard = ({ GrowerId }) => {
  const {
    data: growerDetailData,
    isLoading: isGrowerDeatilLoading,
    refetch: refetchGrowerList,
  } = useGet(ENDPOINTS.GROWER_DETAIL, QUERY_KEYS.GROWER_DETAIL_QUERY_KEY, {
    growerId: GrowerId,
  });
  const GrowerDetailById = growerDetailData?.data;
  useEffect(() => {
    refetchGrowerList();
  }, [GrowerId]);
  return (
    <div className="detail_wrapper_card">
      <div className="row gy-3 gx-4 gx-xxl-5">
        <div className="col-md-6 col-lg-4">
          <div className="common-statistics">
            <div className="common-info-detail">
              <h2 className="h4">Grower ID</h2>
              <p className="mb-0">{GrowerDetailById?._id}</p>
            </div>
            <div className="common-info-detail">
              <h2 className="h4">Phone Number</h2>
              <p className="mb-0">
                {GrowerDetailById?.countryCode && GrowerDetailById?.phoneNumber
                  ? `+ ${GrowerDetailById.countryCode} ${GrowerDetailById.phoneNumber}`
                  : "NA"}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4">
          <div className="common-statistics">
            <div className="common-info-detail">
              <h2 className="h4">Grower</h2>
              <p className="mb-0">{`${GrowerDetailById?.firstName} ${GrowerDetailById?.lastName}`}</p>
            </div>
            <div className="common-info-detail">
              <h2 className="h4">Location</h2>
              <p className="mb-0">{GrowerDetailById?.location}</p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4">
          <div className="common-statistics">
            <div className="common-info-detail">
              <h2 className="h4">Email Address</h2>
              <p className="mb-0">{GrowerDetailById?.email || "NA"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrowerDetailCard;
